<template>
    <div
        v-if="data && data.length"
        class="guide"
        data-type="anchor"
        data-anchor="guide"
        ref="guide"
    >
        <div class="guide-title">
            <h4 class="guide-title-main">测评报告</h4>
            <span></span>
            <h5 class="guide-title-sub">数据来源于有驾合作伙伴盖得排行</h5>
        </div>
        <div class="guide-content">
            <div class="guide-logo">
                <img src="@/common/images/car-train/guide.png" >
            </div>
            <div class="guide-cover">
                <div class="guide-text" :style="{height: textHeight}">
                    <div ref="text-content">
                        <template v-for="(item, idx) in data">
                            <p>{{item.text}}</p>
                            <br v-if="idx !== data.length - 1">
                        </template>
                    </div>
                </div>
                <div class="guide-watch-more" @click="watchMoreGuide">
                    <span>{{fold ? '收起' : '查看更多'}}</span>
                    <i class="c-icon" :class="{isActive: fold}">&#xe60f;</i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file 盖得排行
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {scrollTop} from 'js/Utils';

export default {
    props: {
        seriesId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fold: false,
            textHeight: '130px',
            data: []
        };
    },
    watch: {
        seriesId(val) {
            this.getData(val);
        }
    },
    methods: {
        watchMoreGuide() {
            if (this.fold) {
                this.textHeight = '130px';
                scrollTop(
                    window,
                    document.documentElement.scrollTop
                        || document.body.scrollTop,
                    this.$refs.guide.offsetTop - 79
                );
            }
            else {
                const {clientHeight} = this.$refs['text-content'];
                this.textHeight = clientHeight ? clientHeight + 'px' : 'auto';
            }
            this.fold = !this.fold;
            this.$emit('change', !this.fold);
        },
        getData(seriesId) {
            /* eslint-disable fecs-camelcase */
            request(URLS.getSeriesEvaluationReport, {
                series_id: seriesId
            })
                .then(res => {
                    const data = res.Result.evaluationreport;
                    this.data = data;
                    this.$emit('getdatastatus', 'guide', data && data.length > 0);
                })
                .catch(err => {
                    this.$emit('getdatastatus', 'guide', false);
                });
            /* eslint-enable fecs-camelcase */
        }
    }
};
</script>

<style lang="less" scoped>
.guide {
    margin-top: 53px;
    &-title {
        display: flex;
        align-items: flex-end;
        padding-bottom: 23px;
        border-bottom: 1px solid #EEEEEE;
        align-items: center;
        &-main {
            font-size: 20px;
            line-height: 20px;
            color: #333333;
        }
        &-sub {
            font-size: 14px;
            line-height: 14px;
            color: #999999;
        }
        span {
            display: flex;
            width: 1px;
            height: 20px;
            margin: 0 12px;
            background: #EEEEEE;
        }
    }
    &-content {
        padding-top: 20px;
        display: flex;
        .guide-logo {
            width: 130px;
            height: 130px;
            margin-right: 26px;
            img {
                display: flex;
                width: 100%;
                height: 100%;
            }
        }
        .guide-cover {
            flex: 1;
        }
        .guide-text {
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            overflow: hidden;
            transition: height .2s linear;
            p {
                text-indent: 2em;
            }
        }
        .guide-watch-more {
            margin-top: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            line-height: 16px;
            color: #666666;
            cursor: pointer;
            >span {
                display: inline-block;
            }
            i {
                display: inline-block;
                margin-left: 9px;
                &.isActive {
                    transform: rotate(-180deg);
                }
            }
        }
    }
}
</style>
